import { useEffect, useState } from "react";

import HexCard from "../../../../components/HexCard";
import HexTitle from "../../../../components/HexTitle";

import { getLabel } from "../../../../hooks/use-labels";

import {
  getStorageItem,
  showErrorNotification,
} from "../../../../utils/common-utils";

import CouponFieldView from "./CouponFieldView";
import AppliedCouponView from "./AppliedCouponView";

import { saveOrderDetails } from "../../ShoppingCart/CartDetailsView/cart-details-utils";

import ProductUpdatedModal from "../../ShoppingCart/Components/ProductUpdatedModal";

const CouponCard = ({ goToCart }) => {
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponDetails, setCouponDetails] = useState({});
  const [error, setError] = useState("");
  const [invalidProduct, setInvalidProduct] = useState(false);

  useEffect(() => {
    const orderInfo = getStorageItem("orderInfo");

    if (orderInfo) {
      const { coupon, couponDiscount } = orderInfo.cartInfo;

      coupon && setCouponDetails({ code: coupon.code, ...couponDiscount });
      coupon && setCouponApplied(true);
    }
  }, []);

  const setOrderInfo = (code) => {
    setError("");

    const otherRequest = code ? { couponCode: code } : { couponCode: null };
    saveOrderDetails(
      {
        successCB: () => {
          const { cartInfo } = getStorageItem("orderInfo");
          setCouponDetails(code ? { code, ...cartInfo.couponDiscount } : {});
          setCouponApplied((prev) => !prev);
        },
        errorCB: ({ message, code }) => {
          if (code.includes("coupon.")) {
            setError(message);
          } else if (code.includes("cart.empty")) {
            setInvalidProduct(true);
          } else {
            goToCart();
            showErrorNotification({ title: "Error", body: message });
          }
        },
      },
      otherRequest
    );
  };

  const onApply = (code) => {
    setOrderInfo(code);
  };

  const onRemove = () => {
    setOrderInfo();
  };

  return (
    <HexCard className={"first-card content-card card-bottom-divider"}>
      <HexTitle
        title={getLabel("couponCardLabel")}
        className={"font-18-regular-500-lh-22 mb-12"}
      />

      {invalidProduct && <ProductUpdatedModal onBack={goToCart} />}

      {!couponApplied && <CouponFieldView onApply={onApply} error={error} />}
      {couponApplied && (
        <AppliedCouponView onRemove={onRemove} couponDetails={couponDetails} />
      )}
    </HexCard>
  );
};

export default CouponCard;
